var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowLongBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16671 10.75C3.75249 10.75 3.41671 10.4142 3.41671 10C3.41671 9.58579 3.75249 9.25 4.16671 9.25V10.75ZM16.3637 9.46967C16.6566 9.76256 16.6566 10.2374 16.3637 10.5303L11.5907 15.3033C11.2978 15.5962 10.823 15.5962 10.5301 15.3033C10.2372 15.0104 10.2372 14.5355 10.5301 14.2426L14.7727 10L10.5301 5.75736C10.2372 5.46447 10.2372 4.98959 10.5301 4.6967C10.823 4.40381 11.2978 4.40381 11.5907 4.6967L16.3637 9.46967ZM4.16671 9.25H15.8334V10.75H4.16671V9.25Z",
    fill: "#366EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowLongBlue);
export default __webpack_public_path__ + "static/media/right_arrow_long_blue.53c536144bed4dc863219994cfa90ffe.svg";
export { ForwardRef as ReactComponent };